/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Enum from 'galax/enum/route';

import BuildingAttack from 'galax/config/behavior/building.attack';
import BuildingCreate from 'galax/config/behavior/building.create';
import BuildingUpgrade from 'galax/config/behavior/building.upgrade';

import UnitAttack from 'galax/config/behavior/unit.attack';
import UnitCreate from 'galax/config/behavior/unit.create';

import SectorTransfer from 'galax/config/behavior/sector.transfer';
import ZoneFlow from 'galax/config/behavior/zone.flow'

import Welcome from 'galax/config/behavior/welcome'
import Manual from 'galax/config/behavior/manual'


let Config = {};


Config[Enum.BuildingAttack]      = BuildingAttack;
Config[Enum.BuildingCreateList]  = BuildingCreate;
Config[Enum.BuildingCreateType]  = BuildingCreate;
Config[Enum.BuildingUpgrade]     = BuildingUpgrade;

Config[Enum.UnitAttack]          = UnitAttack;
Config[Enum.UnitCreateList]      = UnitCreate;
Config[Enum.UnitCreateType]      = UnitCreate;

Config[Enum.ZoneFlow]            = ZoneFlow;

Config[Enum.TransferEdit]        = SectorTransfer;

Config[Enum.WelcomeManual]       = Manual;
Config[Enum.WelcomeLogin]        = Manual;

Config[Enum.WelcomeAbout]        = Welcome;
Config[Enum.WelcomeTerms]        = Welcome;
Config[Enum.WelcomePrivacy]      = Welcome;


export default Config;
